import React, { useRef, useState } from "react";
import { MdDelete } from "react-icons/md";
import PrintQuestionPaper from "./PrintQuestionPaper";
import { Link } from "react-router-dom";
const CustomQuestionPaper = ({ selectedQuestions, setSelectedQuestions , setPrintContent, printContent}) => {
  // console.log("custom, ", selectedQuestions);
  const customQuestionPaperRef = useRef(null);
  const [schoolName, setSchoolName] = useState("");
  const [subject, setSubject] = useState("");
  const [classInfo, setClassInfo] = useState("");
  const [totalMarks, setTotalMarks] = useState("");
  const [timeForExam, setTimeForExam] = useState("");
  const [marks, setMarks] = useState({});
  const [copiedImage, setCopiedImage] = useState("");
  //  const [printButtonVisible, setPrintButtonVisible] = useState(true);
  const [selectedQuestionsState, setSelectedQuestionsState] =
    useState(selectedQuestions);

  const handlePrint = () => {
    const printContent = customQuestionPaperRef.current.innerHTML;
    console.log(setPrintContent)
    setPrintContent(printContent); 
    // console.log(printContent)
    // const originalDocument = document.body.innerHTML;
    // document.body.innerHTML = printContent;
    // const deleteButtons = document.querySelectorAll(".delete-button");
    // deleteButtons.forEach((button) => {
    //   button.style.display = "none";
    // });

    // setTimeout(() => {
    //   window.print();
    //   document.body.innerHTML = originalDocument;
    //   deleteButtons.forEach((button) => {
    //     button.style.display = "block";
    //   });

    //   // Clear the selected questions state after printing
    //   setSelectedQuestions({});
    //   setTimeout(() => {
    //     window.location.reload();
    //   }, 1000);
    // }, 100);
  };
  // console.log(selectedQuestions["निम्नलिखित पद्यांश का संदर्भ सहित भावार्थ लिखिए-"])
  const handleMarksChange = (questionIndex, event) => {
    const { name, value } = event.target;
    setMarks({ ...marks, [name]: value });
  };

  const removeQuestion = (categoryName, questionIndex) => {
    // console.log("clicked");
    setSelectedQuestions((prevSelectedQuestions) => {
      const updatedSelectedQuestions = { ...prevSelectedQuestions };

      if (updatedSelectedQuestions[categoryName]) {
        updatedSelectedQuestions[categoryName].splice(questionIndex, 1);
      }
      if (updatedSelectedQuestions[categoryName].length === 0) {
        delete updatedSelectedQuestions[categoryName];
      }
      return updatedSelectedQuestions;
    });
  };
  const handleImageClick = (imageUrl) => {
    setCopiedImage(imageUrl);
  };
  return (
    <div className="custom-question-paper" ref={customQuestionPaperRef}>
      <h2 className="heading text-3xl font-semibold custom text-center">
        Custom Question Paper
      </h2>
   <Link to= "/print-question-paper">
   <button  type="button"
        id="print-button"
        className="print-button bg-blue-500 mx-3 my-2 text-white py-2 px-4 rounded mt-4 flex justify-center items-center w-full m-auto"
        onClick={handlePrint}
      >
        View Question Paper
      </button>
   </Link>
      <style>
        {`
          @media print {
      
            body *{
              background-color: #fff;
              color: #000;
            }

            #print-button {
              display: none;
            }
          .heading{ display: none;}
          }
        `}
      </style>
      <div className=" header w-full mx-auto flex flex-col justify-center items-center">
        <div className=" column flex">
          <label>School Name:</label>
          <input
            className=" px-1 outline-none ml-3 my-1"
            type="text"
            placeholder=" Enter School Name"
            value={schoolName}
            onChange={(e) => setSchoolName(e.target.value)}
          />
        </div>
        <div className="column flex">
          <label>Subject:</label>
          <input
            className=" px-1 outline-none ml-3 my-1"
            type="text"
            placeholder=" Enter Subject"
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
          />
        </div>
        <div className="column flex">
          <label>Class:</label>
          <input
            type="text"
            className=" px-1 outline-none ml-3 my-1"
            placeholder="Enter Class"
            value={classInfo}
            onChange={(e) => setClassInfo(e.target.value)}
          />
        </div>
        <div className="column flex">
          <label>Total Marks:</label>
          <input
            type="text"
            className=" px-1 outline-none ml-3 my-1"
            placeholder="Enter Total Marks"
            value={totalMarks}
            onChange={(e) => setTotalMarks(e.target.value)}
          />
        </div>
        <div className="column flex">
          <label>Total Time (minutes):</label>
          <input
            type="text"
            className=" px-1 outline-none ml-3 my-1"
            placeholder=" Enter Total Time (minutes)"
            value={timeForExam}
            onChange={(e) => setTimeForExam(e.target.value)}
          />
        </div>
      </div>

      {Object.keys(selectedQuestions).map((categoryName, categoryIndex) => (
        <div key={categoryIndex} className=" p-5">
          <h3 className="font-semibold">
            Question {categoryIndex + 1}: {categoryName}
          </h3>

          {selectedQuestions[categoryName].map((question, questionIndex) => (
            <div key={questionIndex} className="question">
              <div className="flex flex-row justify-between items-center">
                {/* Render question text */}
                {question.question ? (
                  <div className="flex  gap-3">
                    <p> Q{questionIndex + 1}: </p>
                    <p>{question.question}</p>
                  </div>
                ) : (
                  <p></p>
                )}
                <button
                  className="delete-button"
                  onClick={() =>
                    removeQuestion(categoryName, questionIndex, question)
                  }
                >
                  <MdDelete />
                </button>
              </div>

              {/* Render image if present */}
              {selectedQuestions[categoryName].length >= 2
                ? question.imgUrl && (
                    <div
                      className="question-image flex gap-2"
                      onClick={() => handleImageClick(question.imgUrl)}
                    >
                      <p>
                      Q{questionIndex + 1}
                      </p>
                      <img src={question.imgUrl} alt="Question Image" />
                    </div>
                  )
                : question.imgUrl && (
                    <div
                      className="question-image flex"
                      onClick={() => handleImageClick(question.imgUrl)}
                    >
                      {/* Q{questionIndex + 1} */}
                      <img src={question.imgUrl} alt="Question Image" />
                    </div>
                  )}

              {/* Render options if present */}
              {question.options && question.options.length > 0 && (
                <div >
                  {/* <p>Options:</p> */}
                  <ul className="flex justify-start items-start gap-5 flex-wrap ">
                    {question.options.map((option, optionIndex) => (
                      <div key={optionIndex} className="ml-3 ">
                        <label>
                          <input disabled
                            type="radio"
                            name={`question_${questionIndex}`}
                            value={option}
                            style={{ display: 'none' }}
                            className="mx-3"
                          />
                          {option}
                        </label>
                      </div>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    {printContent && <PrintQuestionPaper printContent={printContent} />}
    </div>
  );
};

export default CustomQuestionPaper;
